import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-map-stat',
  templateUrl: './form-map-stat.component.html',
  styleUrls: ['./form-map-stat.component.scss']
})
export class FormMapStatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
